import React from 'react';
export function IdentificationSection() {
  const cards = [{
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-98">Repites</span>{' '}
          relaciones que te terminan doliendo
        </>,
    description: 'Aunque prometes que esta vez será distinto, atraes el mismo tipo de dolor o desconexión.'
  }, {
    title: <>
          Sientes <span className="text-terracotta font-semibold" data-id="element-99">culpa</span>{' '}
          cuando empiezas a avanzar
        </>,
    description: 'Un peso inexplicable aparece justo cuando te empieza a ir bien o logras algo que tu familia no pudo.'
  }, {
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-100">Ansiedad</span> sin
          entender realmente por qué
        </>,
    description: 'Miedos profundos que no coinciden con lo que has vivido. Como si el cuerpo supiera algo que tú no.'
  }, {
    title: <>
          Sensación de{' '}
          <span className="text-terracotta font-semibold" data-id="element-101">estancamiento</span>
        </>,
    description: 'Un techo invisible que no te deja crecer, como si algo dentro de ti frenara cada intento de avanzar.'
  }];
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-102">
      <div className="max-w-6xl mx-auto" data-id="element-103">
        <h2 className="font-playfair text-4xl md:text-5xl text-center text-dark mb-14" data-id="element-104">
          ¿Te reconoces en esto?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10" data-id="element-105">
          {cards.map((card, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center border border-dark/5" data-id="element-106">
              <h3 className="font-playfair text-xl font-semibold text-dark mb-4" data-id="element-107">
                {card.title}
              </h3>
              <p className="text-dark/70 font-light leading-relaxed text-sm md:text-base" data-id="element-108">
                {card.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}